import React, { useEffect, useState } from "react";
import "./style.scss";
import {
  Box,
  Card,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import StyledFilledButton from "../../components/ReusableComponents/Button";
import crossIcon from "../../assets/images/crossIcon.svg";
import { useDispatch } from "react-redux";
import { getPayoutVerificationStatus, updatePaymentVerification } from "../../store/reducers/payoutReducer";
import CombinedPopup from "../../components/Popups/CombinedPopup";

const WiseModal = (props) => {
  const { open, wisemodalClose, defaultEmail } = props;
  const [email, setEmail] = useState();
  const dispatch = useDispatch();

  // Pop up states
  // success/ error modal
  const [ShowPopup, setShowPopup] = useState(false);
  const [CombinedPUHead, setCombinedPUHead] = useState("");
  const [CombinedPUBody, setCombinedPUBody] = useState("");
  const [PopUpType, setPopUpType] = useState("");

  const SubmitHandleClose = ()=>{
    wisemodalClose()
  }

  useEffect(()=>{setEmail(defaultEmail)},[defaultEmail])

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      wise_email: email,
      verification_type: "WISE",
    };
    dispatch(updatePaymentVerification(payload))
      .then((res) => {
        console.log(res);
        setShowPopup(true);
        setCombinedPUHead("Woo hoo !");
        setCombinedPUBody("Submitted successfully!");
        setPopUpType("success");
        dispatch(getPayoutVerificationStatus());
      })
      .catch((err) => {
        console.log(err.response?.data?.message);
        let msg = "Failed to submit";
        if(err.response?.data?.message){
          msg = Object.values(err.response?.data?.message);
        }
        setShowPopup(true);
        setCombinedPUBody(msg);
        setCombinedPUHead("Oh snap!");
        setPopUpType("error");
      });
  };

  return (
    <div>
      <CombinedPopup
        type={PopUpType}
        trigger={ShowPopup}
        setTrigger={setShowPopup}
        head={CombinedPUHead}
        subhead={CombinedPUBody}
        onClick={SubmitHandleClose}
      />

      <Modal open={open} onClose={wisemodalClose} className="Modal" style={{zIndex:1}}>
        <Box className="Modal-parent" gap={1} width={{ xs: "80%", md: "40%" }}>
          <Card className="Modal-card bank-form" variant="outlined">
            <div className="title-parent">
              <Typography className="modal-title">Recipient’s WISE Email</Typography>
              <img
                     className="cross-button"
                src={crossIcon}
                alt="crossIcon"
                style={{ cursor: "pointer" }}
                onClick={wisemodalClose}
              />
            </div>
            <Grid
              container
              item
              className="gen-info-form"
              component={"form"}
              rowGap={3}
            >
              <Grid item xs={12} md={12}>
                <div className="form-grp-in">
                  <Typography htmlFor="full-name" className="input-label">
                    Email of the account holder
                  </Typography>
                  <input
                    required
                    type="email"
                    className="input-modal"
                    id="full-name"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={12} onClick={handleSubmit}>
                <div className="form-grp-in">
                  <StyledFilledButton>Confirm</StyledFilledButton>
                </div>
              </Grid>
            </Grid>
          </Card>
        </Box>
      </Modal>
    </div>
  );
};

export default WiseModal;
